<template>
  <div class="landingContentBannerSection">
    <div class="container">
      <div class="landingContentBannerSection__inner">
        <picture v-if="data.Mobile && data.Background">
          <source
            :srcset="$helper.optimizeImageUrl(JSON.parse(data.Mobile).url, 'w_1200,h_500')"
            media="(max-width: 768px)"
          />
          <img
            class="landingContentBannerSection__image"
            :src="$helper.optimizeImageUrl(JSON.parse(data.Background).url, 'w_1400,h_400')"
            alt=""
          />
        </picture>
        <div class="landingContentBannerSection__content">
          <div v-if="data.Description" v-html="data.Description"></div>
          <VButton
            v-if="data.Button.Url && data.Button.LinkText"
            :text="data.Button.LinkText"
            :href="data.Button.Url"
            theme="orange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VButton from '@/components/VButton.vue';

export default {
  name: 'LandingContentBannerSection',
  components: { VButton },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style scoped lang="scss">
.landingContentBannerSection {
  color: $cWhite;
  background: $cWhite;
  padding: 6.4rem 0 0;

  @include rwd('small-tablet') {
    padding: 5.6rem 0 0;
  }

  &__inner {
    background: $cMain;
    position: relative;
    overflow: hidden;

    @include rwd('tablet') {
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
  }

  &__image {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;

    @include rwd('tablet') {
      position: relative;
      margin-left: auto;
      width: 100%;
      object-fit: contain;
    }
  }

  &__content {
    padding: 3.5rem 3.5rem 5rem 6rem;
    max-width: 60rem;
    position: relative;
    z-index: 1;

    @include rwd('small-tablet') {
      padding: 3rem 2rem;
    }
  }

  ::v-deep .button {
    @include rwd('tablet') {
      width: 100%;
    }
  }

  ::v-deep p {
    font-size: 1.6rem;
    line-height: 2.4rem;
    margin-bottom: 2rem;
    font-weight: 500;

    @include rwd('tablet') {
      text-align: center;
    }
  }

  ::v-deep h1,
  ::v-deep h2,
  ::v-deep h3,
  ::v-deep h4,
  ::v-deep h5 {
    font-size: 4.8rem;
    line-height: 1.15;
    font-weight: 600;
    max-width: 48rem;
    margin-bottom: 2rem;

    b,
    strong {
      color: $cSec;
      font-weight: 600;
    }

    @include rwd('large-tablet') {
      font-size: 4rem;
    }

    @include rwd('tablet') {
      text-align: center;
      max-width: 100%;
    }

    @include rwd('small-tablet') {
      text-align: center;
      font-size: 2.8rem;
    }
  }
}
</style>
